import PurchaseHistoryItemComponent from './PurchaseHistoryItem/PurchaseHistoryItem'
import FiltersComponent from '../../../../Filters/Filters'
export const PurchaseHistoryItem = PurchaseHistoryItemComponent
export const Filters = FiltersComponent
